import React from 'react';
import {Box, Container, Text, Flex} from "@chakra-ui/react";

const Advantages = () => {
    return (
        <Box w="full" mb={{base: "112px", md: "50px"}} pt={'75px'}>
            <Container maxW="container.xl" display="flex" justifyContent="center" alignItems="center">
                <Box>
                    <Flex flexDir="column" alignItems="center" justifyContent={{base: "center", md: "start"}}
                          pb={{base: "24px", md: "42px"}}>
                        <Flex fontFamily='Raleway' fontWeight="900" fontSize={{base: "28px", sm: "32px", md: "54px"}}
                              color="#111212" lineHeight={{base: "38px", md: "63px"}}>
                            <Text>Качество&nbsp;</Text>
                            <Text>Инновации </Text>
                        </Flex>
                        <Text textAlign={{base: "center", md: "start"}} as="span" color="#E92F34" fontFamily='Raleway'
                              fontWeight="900" fontSize={{base: "32px", sm: "36px", md: "61px"}}
                              lineHeight={{base: "45px", md: "75px"}}>Профессионализм</Text>
                    </Flex>
                    <Text textAlign={{base: "center", md: "start"}} fontFamily='Raleway' fontWeight="400"
                          fontSize={{base: "14px", sm: "18px"}}>Мы готовы предоставить высококачественную
                        продукцию, <br/>конкурентоспособную цену и отличное обслуживание в качестве <br/> основы для долгосрочного сотрудничества.</Text>
                </Box>
            </Container>
        </Box>
    );
};

export default Advantages;
